import { DesignAction, DesignEvent } from "../../../base/models";
import { DesignerPageHeader, PageDesigner } from "./page-designer";
import { FC, useReducer } from "react";
import { IPage, IPageView } from "../models";
import { PageContextProvider, PageDataContextProvider } from "../context";

import { DesignContextProvider } from "../../../providers";
import { reducer } from "./reducer";

export const PageEditor = ({ page, pageView }: {
    page: IPage,
    pageView: IPageView,
}) => {
    const [localPage, dispatch] = useReducer(reducer, page)

    const onDesignChange = (event: DesignEvent) => {
        dispatch(event)
    }

    const onPageChange = (page: IPage) => {
        dispatch({ type: DesignAction.Update, page })
    }

    if (!localPage) return <></>

    return (
        <PageEditorWrapper page={page} pageView={pageView}>
            <div className="d-flex flex-column gap-5">
                <DesignerPageHeader page={localPage} onChange={onPageChange} />
                <PageDesigner page={localPage} onDesignChange={onDesignChange} />
            </div>
        </PageEditorWrapper>
    )
}

interface IPageEditorWrapper {
    page: IPage,
    pageView: IPageView,
    children?: React.ReactNode,
}

const PageEditorWrapper: FC<IPageEditorWrapper> = ({ page, pageView, children }) => {
    return <>
        <PageContextProvider page={page} pageView={pageView}>
            <PageDataContextProvider page={page} pageView={pageView}>
                <DesignContextProvider>
                    {children}
                </DesignContextProvider>
            </PageDataContextProvider>
        </PageContextProvider>
    </>
}
